import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { AccountTree, ContentCopy, Delete, Edit } from "@mui/icons-material";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const OpenAiAgentNode = memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const options = Array.isArray(data?.arrayOption) ? data.arrayOption : [];

  return (
    <div
      style={{
        minWidth: 230,
        background: "#F5F3FF",
        border: "1px solid #7C3AED",
        borderRadius: 8,
        padding: 10,
        boxShadow: "rgba(0, 0, 0, 0.08) 0 3px 8px",
        cursor: "pointer",
      }}
      title="Duplo clique para editar"
    >
      <Handle
        type="target"
        position="left"
        style={{ background: "#7C3AED", width: 16, height: 16 }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          color: "#4C1D95",
          fontWeight: 600,
          marginBottom: 8,
        }}
      >
        <AccountTree fontSize="small" />
        {data?.label || "Roteador por IA"}
      </div>

      <div style={{ position: "absolute", right: 6, top: 6, display: "flex", gap: 5 }}>
        <Edit
          sx={{ width: 13, height: 13, color: "#7C3AED", opacity: 0.7 }}
        />
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: 13, height: 13, color: "#7C3AED", cursor: "pointer" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: 13, height: 13, color: "#DC2626", cursor: "pointer" }}
        />
      </div>

      <div style={{ fontSize: 11, color: "#5B21B6", marginBottom: 6 }}>
        Decide a fase usando todo o histórico · editável
      </div>

      {options.map((option, index) => {
        const top = 62 + index * 24;
        return (
          <div key={option.id} style={{ minHeight: 24, fontSize: 11, color: "#312E81" }}>
            {option.label}
            <Handle
              type="source"
              position="right"
              id={option.id}
              style={{
                top,
                background: "#7C3AED",
                width: 12,
                height: 12,
              }}
              isConnectable={isConnectable}
            />
          </div>
        );
      })}

      <Handle
        type="source"
        position="right"
        id="default"
        style={{ bottom: 6, top: "auto", background: "#6B7280", width: 12, height: 12 }}
        isConnectable={isConnectable}
      />
    </div>
  );
});

export default OpenAiAgentNode;
